import React from 'react';

export default function Icon({ name, size = 22, color, style, alt, className }) {
  const src = name && name.startsWith('/') ? name : `/icons/${name}`;
  return (
    <span
      role={alt ? 'img' : 'presentation'}
      aria-label={alt}
      className={className}
      style={{
        display: 'inline-block',
        flexShrink: 0,
        width: size,
        height: size,
        backgroundColor: color || 'var(--color-primary)',
        WebkitMaskImage: `url('${src}')`,
        WebkitMaskSize: 'contain',
        WebkitMaskRepeat: 'no-repeat',
        WebkitMaskPosition: 'center',
        maskImage: `url('${src}')`,
        maskSize: 'contain',
        maskRepeat: 'no-repeat',
        maskPosition: 'center',
        ...style,
      }}
    />
  );
}
